module.exports = __webpack_public_path__ + "img/succes-pin@3x.5f388f9a.png";